import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { noop } from 'ui-components/default-props/noop';

import { getRewardedModalMessages } from './messages';
import styles from './migration-plan-get-rewarded-modal.module.css';
import StandardOrPremiumPlanFeaturesSVG from './standard-or-premium-plan-features.svg';
import { SimpleModal } from '../../../../../components/simple-modal';
import { Segment } from '../../../../../services/analytics-services/segment';

const PLAN_MIGRATION_TOUR_NEW_FEATURES = 'PLAN_MIGRATION_TOUR_NEW_FEATURES';

/**
 * @typedef {object} MigrationPlanGetRewardedModalProps
 * @property {() => void} onClose
 */

/**
 * @param {MigrationPlanGetRewardedModalProps} props
 * @returns {JSX.Element}
 */
export const MigrationPlanGetRewardedModal = ({ promotionalPlanDetails, onClose = noop }) => {
  const intl = useIntl();

  const onClick = useCallback(() => {
    Segment.trackEvent(PLAN_MIGRATION_TOUR_NEW_FEATURES);
    onClose();
  }, [onClose]);

  return (
    <SimpleModal
      actionButtonDataAmplitudeId={`${promotionalPlanDetails.name}`}
      actionMessage={getRewardedModalMessages.tourNewFeatures}
      headerMessage={getRewardedModalMessages.title}
      onAction={onClick}
      onClose={onClose}
      size='medium'
    >
      <FlexColumn className={styles['get-rewarded-modal']} gap={Gap.Space12}>
        <img alt={intl.formatMessage(getRewardedModalMessages.imageAlt)} className={styles.image} src={StandardOrPremiumPlanFeaturesSVG} />
        <Text
          formattedMessageValues={{ plan: promotionalPlanDetails.name }}
          textType={TextType.H3}
          value={getRewardedModalMessages.header}
        />
        <Text
          formattedMessageValues={{ plan: promotionalPlanDetails.name }}
          textType={TextType.Paragraph}
          value={getRewardedModalMessages.body}
        />
      </FlexColumn>
    </SimpleModal>
  );
};
